import React, { ReactNode, ReactNodeArray, useRef, useState } from 'react';
import { nanoid } from 'nanoid';

interface IProps {
  children: ReactNode | ReactNodeArray;
  onChange?: (value: string | number) => void;
  destroyWhenHidden?: boolean;
}

export const TabContext = React.createContext({
  id: null,
  value: null,
  onChange: null,
  destroyWhenHidden: false,
});

function TabContextElement({ children, onChange, destroyWhenHidden = false }: IProps) {
  const id = useRef(nanoid(10));
  const [value, setValue] = useState<string | number>(null);

  const onChangeHandler = (value: string | number) => {
    setValue(value);
    onChange && onChange(value);
  };

  return (
    <TabContext.Provider value={{ id: id.current, value, onChange: onChangeHandler, destroyWhenHidden }}>
      {children}
    </TabContext.Provider>
  );
}

export default TabContextElement;
